/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
import * as i0 from "@angular/core";
import * as i1 from "./toolbar-item-unlock-form.component";
import * as i2 from "../../../../../../form-viewer/form.service";
var styles_ToolbarItemUnlockFormComponent = [];
var RenderType_ToolbarItemUnlockFormComponent = i0.ɵcrt({ encapsulation: 2, styles: styles_ToolbarItemUnlockFormComponent, data: {} });
export { RenderType_ToolbarItemUnlockFormComponent as RenderType_ToolbarItemUnlockFormComponent };
export function View_ToolbarItemUnlockFormComponent_0(_l) { return i0.ɵvid(2, [], null, null); }
export function View_ToolbarItemUnlockFormComponent_Host_0(_l) { return i0.ɵvid(0, [(_l()(), i0.ɵeld(0, 0, null, null, 1, "toolbar-item-unlock-form", [], null, null, null, View_ToolbarItemUnlockFormComponent_0, RenderType_ToolbarItemUnlockFormComponent)), i0.ɵdid(1, 245760, null, 0, i1.ToolbarItemUnlockFormComponent, [i2.FormService], null, null)], function (_ck, _v) { _ck(_v, 1, 0); }, null); }
var ToolbarItemUnlockFormComponentNgFactory = i0.ɵccf("toolbar-item-unlock-form", i1.ToolbarItemUnlockFormComponent, View_ToolbarItemUnlockFormComponent_Host_0, { params: "params" }, {}, []);
export { ToolbarItemUnlockFormComponentNgFactory as ToolbarItemUnlockFormComponentNgFactory };
